import { Pipe, PipeTransform } from "@angular/core";

/**
 * Replace YouTube URLs with the no-cookie counterpart
 */
@Pipe({
  name: "youtube",
})
export class YoutubePipe implements PipeTransform {
  transform(value: string, ...args: unknown[]): unknown {
    const noCookieDomain = value.replace("youtube.com", "youtube-nocookie.com");
    return noCookieDomain;
  }
}
